import styles from "../../moveout-checklist.module.css";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useState } from "react";
import LivingRoomForm from "./components/LivingRoomForm";
import KitchenForm from "./components/KitchenForm";
import BathroomForm from "./components/BathroomForm";
import BedroomForm from "./components/BedroomForm";
import OtherFormForm from "./components/OtherForm";

const ArrivalForm = (props) => {
  const [expanded, setExpanded] = useState("");

  const handleChange4 = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  }

  return (
    <div>
      <Accordion
        expanded={expanded === "panel1"}
        onChange={handleChange4("panel1")}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
          <div className={`${styles.FormAccoHead}`}>
            <p className={`${styles.FormAccoHeadTitle}`}>Living Room</p>
          </div>
        </AccordionSummary>
        <AccordionDetails className={`${styles.CussAccoRow}`}>
          {/* <ToggleButtonGroup
            color="primary"
            value={checkTime}
            exclusive
            onChange={handleChange}
            aria-label="Platform"
            className="CheckListToggle"
          >
            <ToggleButton value="arrival">
              <LogIn />
              Arrival
            </ToggleButton>
            <ToggleButton value="departure">
              <LogOut />
              Departure
            </ToggleButton>
          </ToggleButtonGroup> */}
          <LivingRoomForm {...props} handleChange4={handleChange4} />
        </AccordionDetails>
      </Accordion>
      <Accordion
        expanded={expanded === "panel2"}
        onChange={handleChange4("panel2")}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
          <div className={`${styles.FormAccoHead}`}>
            <p className={`${styles.FormAccoHeadTitle}`}>Kitchen/Other</p>
          </div>
        </AccordionSummary>
        <AccordionDetails className={`${styles.CussAccoRow}`}>
          {/* <ToggleButtonGroup
            color="primary"
            value={checkTime}
            exclusive
            onChange={handleChange}
            aria-label="Platform"
            className="CheckListToggle"
          >
            <ToggleButton value="arrival">
              <LogIn />
              Arrival
            </ToggleButton>
            <ToggleButton value="departure">
              <LogOut />
              Departure
            </ToggleButton>
          </ToggleButtonGroup> */}
          <KitchenForm {...props} handleChange4={handleChange4} />
        </AccordionDetails>
      </Accordion>
      <Accordion
        expanded={expanded === "panel3"}
        onChange={handleChange4("panel3")}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
          <div className={`${styles.FormAccoHead}`}>
            <p className={`${styles.FormAccoHeadTitle}`}>Bathroom(s)</p>
          </div>
        </AccordionSummary>
        <AccordionDetails className={`${styles.CussAccoRow}`}>
          {/* <ToggleButtonGroup
            color="primary"
            value={checkTime}
            exclusive
            onChange={handleChange}
            aria-label="Platform"
            className="CheckListToggle"
          >
            <ToggleButton value="arrival">
              <LogIn />
              Arrival
            </ToggleButton>
            <ToggleButton value="departure">
              <LogOut />
              Departure
            </ToggleButton>
          </ToggleButtonGroup> */}
          <BathroomForm {...props} handleChange4={handleChange4} />
        </AccordionDetails>
      </Accordion>
      <Accordion
        expanded={expanded === "panel4"}
        onChange={handleChange4("panel4")}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
          <div className={`${styles.FormAccoHead}`}>
            <p className={`${styles.FormAccoHeadTitle}`}>Bedroom</p>
          </div>
        </AccordionSummary>
        <AccordionDetails className={`${styles.CussAccoRow}`}>
          {/* <ToggleButtonGroup
            color="primary"
            value={checkTime}
            exclusive
            onChange={handleChange}
            aria-label="Platform"
            className="CheckListToggle"
          >
            <ToggleButton value="arrival">
              <LogIn />
              Arrival
            </ToggleButton>
            <ToggleButton value="departure">
              <LogOut />
              Departure
            </ToggleButton>
          </ToggleButtonGroup> */}
          <BedroomForm {...props} handleChange4={handleChange4} />
        </AccordionDetails>
      </Accordion>
      <Accordion
        expanded={expanded === "panel5"}
        onChange={handleChange4("panel5")}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
          <div className={`${styles.FormAccoHead}`}>
            <p className={`${styles.FormAccoHeadTitle}`}>Other</p>
          </div>
        </AccordionSummary>
        <AccordionDetails className={`${styles.CussAccoRow}`}>
          {/* <ToggleButtonGroup
            color="primary"
            value={checkTime}
            exclusive
            onChange={handleChange}
            aria-label="Platform"
            className="CheckListToggle"
          >
            <ToggleButton value="arrival">
              <LogIn />
              Arrival
            </ToggleButton>
            <ToggleButton value="departure">
              <LogOut />
              Departure
            </ToggleButton>
          </ToggleButtonGroup> */}
          <OtherFormForm {...props} handleChange4={handleChange4} />
        </AccordionDetails>
      </Accordion>
    </div>
  );
};

export default ArrivalForm;
